import React from "react";
import QPhototModuleSubtopic from "../../../QPhotoModuleSubtopic";

const AsymptoticAnalysisRecurrences = () => (
  <QPhototModuleSubtopic
    title="Asymptotic analysis for recurrence relation: Iteration Method, Substitution Method, Master Method, Recursive Tree Method"
    videos={[
      "https://www.youtube.com/embed/RKg0oQ5j1po",
      "https://www.youtube.com/embed/ZUE8Qi4sRBo",
      "https://www.youtube.com/embed/x0n75VFd31U",
      "https://www.youtube.com/embed/icS-e8RaCyo",
      "https://www.youtube.com/embed/OynWkEj0S-s",
      "https://www.youtube.com/embed/bJg_sv7PV-g"
    ]}
    takeaways={[
      { text: "1) If there is one topic from this module that you get a question in any exam, it’s that topic." },
      { text: "2) Try as many examples as possible." },
      { text: "3) From master method mostly 3 or 5 mark questions are possible." },
      { text: "4) Pro tip for exams: If you know the answer for the question given in exam, derive the question from answer (this works only if your teacher is a bit lenient)." }
    ]}
    questions={[
      {image:"/dsa_3.png"},
      {image:"/dsa_4.png"},
      {image:"/dsa_5.png"},
      { text: "Generate polynomial functions for the following three code segments and compute the time complexity. (3+3+4) ",
        image:"/dsa_19.png"
       },
      { text: "Solve the following recurrence using recurrence tree method: T(n)=T(n/5)+T(4n/5)+n" },
      { text: "Solve the following recurrences using Master’s method: \n- T(n)=2T(n-1)+n \n- T(n)=4T(n/2)+n^3 log^2 n" },
      { text: "Compute the Time complexity of the following function: \nFunction(){ \n int i,j,k; \n for(i=n; i>=n/2; i--) \n for(j=1; j<=n; j=3*j) \n for(k=1; k<=n; k=k*3) \n printf(\"Hello\"); \n }" },
      { text: "Solve the following Recurrence Relation using Recursive Tree Method: \n T(n)=\n { 1  if n=1 \n { 2T(n/2)+n  if n>1" },
      { text: "Solve the recurrence T(n)=9T(n/3)+n^2 log n using: \na) Backward Substitution method \nb) Master’s Theorem" },
      { text: "Recall the Master's theorem for finding the time complexity of decreased recurrence relation." },
      { text: "Consider the Recurrence relation T(n)=2T(n/2)+n if n>1. Find the asymptotic bound on T by using recursive tree method." },
      { text: "Apply the Recursion Tree Method and express the following function T(n) in asymptotic notation: T(n)=2T(n/2)+3n." },
      { text: "Determine the average processing time T(n) of the recursive algorithm random(int n) which spends one time unit to return a random integer in [0, n] and other instructions take negligible time (e.g., T(0)=0)." ,
        image:"/dsa_6.png"
      },
      { text: "State Master Theorem with all cases and for the following recurrence give an expression for the runtime T(n) if solvable by Master Theorem. Otherwise, indicate non-applicability: T(n)=2T(n/4)+n^{0.51}" },
      { text: "Find the worst-case time complexity for the given iterative algorithm using summation formulas. Assume input array is unsorted.",
        image:"/dsa_7.png"
       },
      { text: "Solve the given recurrence relation using recursive tree method." ,
        image:"/dsa_8.png"
      },
      { text: "Find the time complexity of given recurrence relation using substitution method.",
        image:"/dsa_9.png"
       },
      { text: "Find time complexity of the recursive relation using back substitution method.",
        image:"/dsa_10.png"
       },
      { text: "Solve the recurrence T(n)=T(n/3)+T(2n/3)+cn where c is constant and n is input size, using substitution or iterative (back substitution) method." },
      { text: "Solve the recurrence T(n) = 3T(n/4) + cn^2 using recursive tree method." },
      { text: "Find the time complexity of given code snippet assuming no syntax errors.",
        image:"/dsa_11.png"
       },
      { text: "Compute the time complexity of the given function.",
        image:"/dsa_12.png"
       },
      { text: "Derive the recurrence function for the given code and find the Time complexity using Master’s Theorem.",
        image:"/dsa_13.png"
       },
      { text: "Find the asymptotic complexity for function T(n) using Recursive Tree Method.",
        image:"/dsa_14.png"
       },
      { text: "Compute the time complexity of the program showing all steps involved.",
        image:"/dsa_15.png"
       },
      { text: "The code determines whether all elements in an array are distinct. Identify the operation and calculate worst case time complexity.",
        image:"/dsa_16.png"
       },
      { text: "Analyse the time complexity of the given code snippet.",
        image:"/dsa_17.png"
       },
      { text: "Solve the recursion equation T(n) using recursive tree Method.",
        image:"/dsa_18.png"
       },
      { text: "Write pseudocode to find factorial of an integer using recursion. Write its recurrence relation and compute its time complexity, using substitution method." }
    ]}
    exampleVideos={[]}
  />
);

export default AsymptoticAnalysisRecurrences;
